<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from 'vue-router';
import { useServiceStore } from "@/stores/serviceStore";
import { useRequestsStore } from "@/stores/storeRequests";
import ServiceWeekSlider from "@/components/services_view/ServiceWeekSlider.vue";
import BaseCheckboxTime from "@/components/ui/BaseCheckboxTime.vue";

const storeService = useServiceStore();
const storeRequests = useRequestsStore();
const router = useRouter()

const courtId = ref(sessionStorage.getItem('courtIdToken'))

const isCourtSelected = computed(() => Object.keys(storeService.selectedCourt).length > 0);
const totalPrice = computed(() => isCourtSelected.value ? storeService.courtTimes.reduce((acc, item) => acc + item.price, 0) : storeService.courtTimes[0].price);

const nextSreen = async () => {   
    storeService.goToScreen(storeService.screens.bookings)
    router.push({ hash: `#${storeService.screens.bookings}`})
    storeRequests.responseOk = null
}

const previousSreen = () => {
    storeService.goToScreen(storeService.screens.rentalCourt)
    router.push({ hash: `#${storeService.screens.rentalCourt}`})
    storeRequests.responseError = null
}

let currentDate = new Date();
let formattedDate = currentDate.toISOString().split('T')[0]; 
let nextDay = new Date(currentDate);
nextDay.setDate(currentDate.getDate() + 1);
let formattedNextDay = nextDay.toISOString().split('T')[0];

const parametrs = {
    court_id: courtId.value,
    start_date: formattedDate,
    end_date: formattedNextDay,
    limit: 24,
    offset: 0
}
    
onMounted( async () => {
    if(courtId.value) await storeRequests.getCourtsSlots(parametrs);
    storeService.hideScreenLoader()
});
</script>

<template>
	<div class="services-container">
		<div class="container">
			<button class="services-btn-back" @click="previousSreen">
				<svg width="24" height="24"><use href="#back_icon"></use></svg>
				<span>Назад</span>
			</button>
			<h2 class="service-title">Выберите дату и время бронирования</h2>
            <div class="service">
                <div class="calendar">
                    <div class="calendar__block">
                        <ServiceWeekSlider />
                        
                        <div class="calendar__select-time">
                            <template v-if="!storeRequests.loaderBtn">
                                <BaseCheckboxTime :timeList="storeRequests.listCourtDates" :court-id v-if="storeRequests.listCourtDates?.length"></BaseCheckboxTime>
                            </template>
                            <img v-else class="form__loader calendar__loader" width="36" height="36" src="@/assets/img/icons/loader.svg" alt="изображение" />
                        </div>
                    </div>
                    <p class="form-text-error" style="margin-bottom: 10px;" v-if="storeRequests.responseError">{{ storeRequests.responseError }}</p>
                    <button :disabled="!totalPrice" class="calendar__btn btn --full" @click="nextSreen">Далее</button>
                </div>
            </div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.calendar {
	max-width: 73rem;
	margin-left: auto;
	margin-right: auto;
}
.calendar__block {
	display: grid;
	gap: 20px;
    margin-bottom: 100px;
}

.calendar__select-time {
    position: relative;
	display: grid;
	gap: 1.6rem;
}

.calendar__loader {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.select-time__price {
}
.calendar__btn {
    @media (max-width: vars.$x480) {
        width: 85%;
        margin-right: auto;
        margin-left: auto;
    }
}
.btn {
}
.--full {
}
</style>
